module.exports = __webpack_public_path__ + "img/2.213d4afb.jpg";